import type { ReactNode } from 'react';

import type { ToggleTarget } from '../../hooks/useToggleState';
import type { BaseComponentProps, BaseInteractiveComponentProps } from '../../types';
import type { IconProps } from '../Icon';

export interface DetailsSummaryProps
  extends BaseComponentProps,
    BaseInteractiveComponentProps<HTMLDetailsElement> {
  showChevron?: boolean;
  onToggle?: (state: ToggleTarget) => void;
  /** Whether to force the open/close state. */
  open?: boolean;
  summary: ReactNode;
  summaryProps?: BaseComponentProps & BaseInteractiveComponentProps<HTMLElement>;
  chevronProps?: Omit<IconProps, 'name'>;
  detailsRef?: React.RefObject<HTMLDetailsElement>;
  // TODO: figure out why there is no HTMLSummaryElement type
  summaryRef?: React.RefObject<HTMLElement>;
  /**
   * We need this prop because the DetailsSummary component defaults to `open` and is set to not be
   * open via javascript if controlled, which sometimes causes onToggle to fire still (some kind of
   * race condition).
   *
   * Cannot reproduce 100% of the time, but is happening often when using Accordion and Animated
   * Accordion. Adding this prop so we can disable it where problematic until we rewrite
   * DetailsSummary
   */
  disableScrollToOnOpen?: boolean;
  /**
   * Whether to play the default fade-in animations.
   *
   * Turn this off to apply custom animations.
   */
  fadeInAnimation?: boolean;

  /** Duration of the ToggleState.ON and ToggleState.OFF. */
  transitionDurationMs?: number;
  /**
   * Sets default open/close value when component is controlled. This is to prevent shrink/expand
   * animations from firing when controlled on initial render for Accordion.
   *
   * TODO: probably want to refactor this but it's a quick fix for now to test INP improvements.
   */
  defaultControlledState?: boolean;
}

export interface ChevronProps {
  width?: number;
  height?: number;
  color?: string;
}
